<template>
  <div>
    <!-- 试听课程 -->
    <CourseTabs v-if="showHead" :tabsData="tabsData" :sticky="sticky" @onChange="handleTab"/>

    <!-- 简介 -->
    <keep-alive>
      <div v-if="!activeTab">
        <slot></slot>
      </div>

      <!-- 目录 -->
      <CourseCatalog v-else :courseId="courseId" :productType="productType" :boughtCount="boughtCount" :isLogin="isLogin"/>
    </keep-alive>
  </div>
</template>

<script>
import { CourseTabs, CourseCatalog } from './';
import { findComponentUpwardByEvent } from '@/utils/tool';

export default {
  props: {
    showHead: {
      type: Boolean,
      default: true,
    },
    courseId: {
      type: String,
      default: ''
    },
    productType: {
      type: [String, Number],
      default: '',
    },
    // 是否购买
    boughtCount: {
      type: [String, Number],
      default: 0,
    },
    sticky: {
      type: Boolean,
      default: true
    },
    // 是否登陆
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CourseTabs,
    CourseCatalog
  },
  data() {
    return {
      tabsData: [{ name: '简介' }, { name: '目录' }],
      activeTab: 0
    };
  },
  methods: {
    handleTab({ tab, index }) {
      this.activeTab = index;
      const parents = findComponentUpwardByEvent(this, 'setLogTrack');
      if (parents) {
        parents.setLogTrack({
          module_name: '简介/目录',
          btn_name: tab.name,
        }, 'click');
      }
    }
  }
};
</script>
